import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';

import { dismissClockOutApprovalAlert } from 'actions/notifications';

import { formatDate } from 'util/dateTime';
import { browserHistory } from 'util/router';

import AlertsListItem from '../AlertsListItem';

type ClockOutApprovalProps = {
  item: ImmutableMap<string, any>;
};

const ClockOutApproval = ({ item, ...rest }: ClockOutApprovalProps) => {
  const dispatch = useDispatch();

  const handleEdit = useCallback(() => {
    const formattedDate = formatDate(
      item.get('scheduled_start_date'),
      'parsable_date'
    );

    browserHistory.push({
      pathname: '/timesheets/daily_review',
      search: `?date=${encodeURIComponent(formattedDate)}`,
    });
  }, [item]);

  const handleDismiss = useCallback(() => {
    dispatch(dismissClockOutApprovalAlert(item));
  }, [dispatch, item]);

  return (
    <AlertsListItem
      desc={item.get('body')}
      onEdit={handleEdit}
      onDismiss={handleDismiss}
      item={item}
      {...rest}
    />
  );
};

export default memo(ClockOutApproval);
